import React from 'react'
import { useStaticQuery, graphql, Link } from "gatsby"
import styled from "@emotion/styled"
import { GatsbyImage } from "gatsby-plugin-image"
import { PrismicRichText } from '@prismicio/react'
import { ArrowRight, ArrowUUpLeft } from "phosphor-react"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from "swiper";
import Iframe from 'react-iframe'
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/autoplay"

const Newswrap = styled.div`
.button {
    background: linear-gradient(to left, cyan, #e6ffff);
      background-size: 400% 400%;
      animation: gradientShift 7.5s ease infinite;
    margin-bottom: 1vh;
    border-radius: 16px;
    a {
        width: 100%;
        border-radius: 16px;
        display: block;
        text-align: center;
        font-family: 'OpticianSans';
        font-size: 1.2em;
        text-transform: uppercase;
        letter-spacing: 2px;
        color: rgba(0,0,0,0.7);
        transition: all 0.3s ease;
        border-bottom: solid 1px rgba(0,0,0,0);
        padding: 2vh;
        padding-bottom: 1.66vh;
        box-sizing: border-box;
        margin-top: 1vh;
        &.redlink {
            background-color: #000;
            color: #fff;
            margin-top: 4vh;
            &:hover {
                background-color: #ed0800;
            }
        } 
    &:hover {
        background-color: black;
        color: white;
    }
    }
}
.swiper {
    width: 24vw;
    padding-bottom: 1vh;
    background: #fff;
    @media (max-width: 599px) {
        width: 90vw;
    }
}
.swiper-slide {
    margin-bottom: 2vh;
    a {
        color: red;
        font-family: "FaktPro-Normal";
        transition: all 0.3s ease;
        border-bottom: solid 1px transparent;
        &:hover {
            color: #000;
            border-bottom-color: rgba(0,0,0,0.8);
        }
        &.readmore {
          text-transform: uppercase;
          font-size: .75rem;
          letter-spacing: 1px;
        }
        svg {
          display: inline;
          padding-top: 3px;
        }
    }
    .gatsby-image-wrapper [data-main-image] {
        border-radius: inherit !important;
    }
    h3 {
        margin-top: 1.5vh;
        margin-bottom: 3px;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        font-family: "FaktPro-Bold";
        font-size: .8125rem;
    }
    p {
        font-family: "FaktPro-Normal";
        letter-spacing: .5px;
        line-height: 1.33em;
        padding-bottom: .33em;
        color: rgba(0,0,0,0.6);
        strong {
            border-bottom: solid 1px rgba(0,0,0,0.5);
            color: #000;
        }
    }
}
@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
`
const Subhead = styled.h2`
    color: #000;
    background: #fff;
    margin-bottom: 2.5vh;
    font-family: 'OpticianSans';
    font-size: 1.33rem;
    letter-spacing: 1px;
`
const Newslink = styled.div`
text-transform: uppercase;
letter-spacing: 1px;
font-family: "FaktPro-Bold";
font-size: .75rem;
margin: 4vh 0;
a {
  background: #fff;
  padding: 8px 11px;
  border-bottom: solid 1px rgba(0,0,0,0.4);
  transition: all 0.3s ease;
  svg {
    display: inline;
    padding-top: 1px;
  }
  &:hover {
    background: #000;
    border-bottom-color: #fff;
    color: #fff;
  }
}
`
const News = () => {
    const data = useStaticQuery(graphql`
query {
  allPrismicNews(limit: 5, sort: {data: {date: DESC}}) {
    edges {
      node {
        id
        uid
        data {
          banner_image {
            gatsbyImageData(aspectRatio: 1.5)
          }
          title {
            text
          }
          lede_text {
            richText
          }
          body {
            richText
            text
          }
        }
      }
    }
  }    
}     
    `)
    const news = data.allPrismicNews.edges

    return (
        <div>
       
        <Newswrap>
            <Subhead>Latest News</Subhead>
            {/*<div className="button"><a href="https://gutsyradio.beehiiv.com/" target="_blank" rel="noreferrer">Get Our Newsletter</a></div>*/}
            <Swiper 
                speed={600}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination, Autoplay]}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
            >
            {news.map(({ node }) =>
                <SwiperSlide key={node.id}>
                    <div>
                    <GatsbyImage image={node.data.banner_image.gatsbyImageData} alt="image" />
                    <h3>{node.data.title.text}</h3>
                    <PrismicRichText
                    field={node.data.lede_text.richText}
                    />
                    {node.data.body.text &&
                      <p><Link to={`/news/${node.uid}`} className="readmore">Read more <ArrowRight color="#ff0000" /></Link></p>
                    }
                    </div>
                </SwiperSlide>
            )}
            </Swiper>
            <Newslink><Link to="/news">See all news <ArrowUUpLeft weight="bold" /></Link></Newslink>
        </Newswrap>

         <Newswrap>
            {/*<Subhead>Subscribe</Subhead>*/}
            <Iframe url="https://embeds.beehiiv.com/656e7df9-8986-421c-83ad-0e26eca01f88"
                data-test-id="beehiiv-embed" 
                width="100%" 
                height="300" 
                frameborder="0" 
                scrolling="no" 
                style="border-radius: 4px; border: 2px solid #e5e7eb; margin: 0; background-color: transparent;"/>
        </Newswrap>
        </div>
    )
}

export default News